import React from 'react'
import { useTranslation } from 'react-i18next'

function Testimonials() {
  const { t } = useTranslation()

  const testimonials = [
    t('testimonials.caelyn', { returnObjects: true }),
    t('testimonials.christie', { returnObjects: true }),
    t('testimonials.matthew', { returnObjects: true }),
  ]

  return (
    <section className="tc-testimonials-style1">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <h6 className="fsz-18 text-uppercase lh-4 marcellus">
              {t('testimonials.titleLine1')} <br /> {t('testimonials.titleLine2')}
            </h6>
            <div className="lg-icon color-brown2">
              <i className="la la-quote-right"></i>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="tc-clients-style1">
              <div className="clients-slider1">
                <div className="swiper-wrapper">
                  {testimonials.map((client, index) => (
                    <div className="swiper-slide" key={index}>
                      <div className="clients-card">
                        <div className="text fsz-20 fw-500 lh-2 marcellus">"{client.text}"</div>
                        <div className="author">
                          <div className="au-inf">
                            <h6 className="text-capitalize mb-2 fsz-16 fw-bold">{client.name}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="slider-controls">
                  <div className="swiper-button-prev"></div>
                  <div className="swiper-pagination"></div>
                  <div className="swiper-button-next"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="marq-slider">
        <div className="swiper-wrapper">
          <div className="swiper-slide">
            <a href="#/" className="marcellus"> Authentic </a>
          </div>
          <div className="swiper-slide">
            <a href="#/" className="marcellus"> Custom </a>
          </div>
          <div className="swiper-slide">
            <a href="#/" className="marcellus"> Jewelry </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Testimonials
